module.exports = __webpack_public_path__ + "img/43_73.9be22a76.png";